query MobileSdkTestFilterOptions($testId: ConditionID!, $limit: Int = 1000) {
	filter_groups: issues(run_id_eq: $testId, deleted_eq: { value: false }, limit: $limit) {
		type_name_group_uniq_array
	}
	scan_groups: issues(run_id_eq: $testId, deleted_eq: { value: false }, limit: $limit, group: [scan_id]) {
		scan_id
		scan_name_any
	}
	all_scan_names: msdk_scans_list(run_id_eq: $testId, limit: $limit) {
		scan_id
		scan_name
	}
}
